import React from 'react';
import { Link, useHistory } from "react-router-dom";
import { auth } from '../firebase';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';


const NavBar = ({user}) => {

const history = useHistory();

const SignOut = () => {
    auth.signOut();
    history.push("");
}
    return (
        <div className="nav-bar">
            <div className="account">
                <Avatar alt="Avatar" src={user.photoURL} className="avatar"/>
                <h5>Logged in as: </h5>
                <h4>{user.displayName}</h4>
            </div>
            
            <div className="menu">
                <Link className="links" to="/"> All recipes </Link>
                
                <Link className="links" to="/new"> Add New recipe </Link>
                <Button
                    className="logout-button"
                    onClick={SignOut}
                    startIcon={<ExitToAppIcon />}>
                    Sign Out
                </Button>
            </div>
        </div>
    )
}

export default NavBar;
